// Date 2023-09-06 09:52:43

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import sithMomMaterialDrawingInfoList from "@/views/sithMesII/pds/SithMomMaterialDrawingInfoList.vue";
import sithMomMaterialDrawingInfoEdit from "@/views/sithMesII/pds/SithMomMaterialDrawingInfoEdit.vue";
import SithMomPjDocument from "@/views/sithMesII/pds/SithMomPjDocument.vue"
import SithMomPjBCInfo from "@/views/sithMesII/pds/SithMomPjBCInfo.vue"
import SithMomPjReleaseBatch from "@/views/sithMesII/pds/SithMomPjReleaseBatch.vue";
// import SithMomPjReleaseItem from "@/views/sithMesII/pds/SithMomPjReleaseItem.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/sithMesII/pds/sithMomMaterialDrawingDownloadRecord/list",
        name: "sithMomMaterialDrawingDownloadRecordList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/sithMesII/pds/sithMomMaterialDrawingDownloadRecord/edit",
        name: "sithMomMaterialDrawingDownloadRecordEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/sithMesII/pds/sithMomMaterialDrawingInfoList",
        name: "sithMomMaterialDrawingInfoList",
        component: sithMomMaterialDrawingInfoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMesII/pds/sithMomMaterialDrawingInfoEdit",
        name: "sithMomMaterialDrawingInfoEdit",
        component: sithMomMaterialDrawingInfoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    //qv
    {
        path: "/sithMesII/qv/pjDocument",
        name: "sithMomPjDocument",
        component: SithMomPjDocument
    },
    {
        path: "/sithMesII/qv/pjBCInfo",
        name: "sithMomPjBCInfo",
        component: SithMomPjBCInfo
    },
    {
        path: "/sithMesII/qv/pjRelease",
        name: "sithMomPjRelease",
        component: SithMomPjReleaseBatch
    },
    // {
    //     path: "/sithMesII/qv/pjReleaseItem",
    //     name: "sithMomPjReleaseItem",
    //     component: SithMomPjReleaseItem
    // },
]
